import { BaseSdk } from '../../base.sdk';

export class OAuthSdk extends BaseSdk {
    async authorize(clientId: string, scopes?: string[]) {
        return await this.post<{ code: string }>({ path: `${this.oauthPath}/authorize?clientId=${clientId}` });
    }
}
